import { useApiClient } from '../../hooks/useApiClient';
import { Disparity } from '../../types/Disparity/Disparity.type';
import { NewDisparity } from '../../types/Disparity/NewDisparity.type';

export const useDisparityApi = () => {
  const apiClient = useApiClient();

  return {
    getDisparityById: (disparityId: number): Promise<Disparity> => {
      return apiClient(`/disparities/${disparityId}`);
    },

    updateDisparity: (disparityId: number, updateData: Partial<NewDisparity>): Promise<Disparity> => {
      return apiClient(`/disparities/${disparityId}`, {
        method: 'PATCH',
        body: JSON.stringify(updateData),
      });
    },
  };
};
